var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"progress-bar-wrapper"},[(!_vm.isProcessing)?[_c('div',{staticClass:"progress-counter"},[_vm._v(" "+_vm._s(_vm.progress + '%')+" ")]),_c('div',{staticClass:"progress-bar-container"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.progress + '%' })})])]:[_c('loader')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }